import React from 'react';

interface DecommissionIconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const DecommissionIcon = ({
    fill = 'black',
    height = 12,
    width = 12,
}: DecommissionIconProps) => (
    <svg width={width} height={height} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            fill={fill}
            d="M11.6484 1.41211H0.351562C0.157406 1.41211 0 1.56952 0 1.76367V3.88184C0 4.07599 0.157406 4.2334 0.351562 4.2334H0.706055V10.2363C0.706055 10.4305 0.863461 10.5879 1.05762 10.5879H10.9424C11.1365 10.5879 11.2939 10.4305 11.2939 10.2363V4.2334H11.6484C11.8426 4.2334 12 4.07599 12 3.88184V1.76367C12 1.56952 11.8426 1.41211 11.6484 1.41211ZM10.5908 9.88477H1.40918V4.2334H10.5908V9.88477ZM11.2969 3.53027H0.703125V2.11523H11.2969V3.53027Z"
        />
        <path
            fill={fill}
            d="M5.29395 7.05762H6.70605C7.28923 7.05762 7.76367 6.58317 7.76367 6C7.76367 5.41683 7.28923 4.94238 6.70605 4.94238H5.29395C4.71077 4.94238 4.23633 5.41683 4.23633 6C4.23633 6.58317 4.71077 7.05762 5.29395 7.05762ZM5.29395 5.64551H6.70605C6.90152 5.64551 7.06055 5.80453 7.06055 6C7.06055 6.19547 6.90152 6.35449 6.70605 6.35449H5.29395C5.09848 6.35449 4.93945 6.19547 4.93945 6C4.93945 5.80453 5.09848 5.64551 5.29395 5.64551Z"
        />
    </svg>
);
